import graphql from "babel-plugin-relay/macro";
import { addDays, format } from "date-fns";
import { useFragment } from "react-relay";

import { useGetClubStartOfWeekNumberPatron } from "@/hooks/useGetClubStartOfWeekNumberPatron";

import { AgendaDateSelectorControlInner } from "./AgendaDateSelectorControlInner";
import { AgendaDateSelectorControlFragment_facility$key } from "./__generated__/AgendaDateSelectorControlFragment_facility.graphql";

type Props = {
  facilityRef: AgendaDateSelectorControlFragment_facility$key | null;
  selectedDate: string;
  onChange?: (date: string) => void;
};
export const AgendaDateSelectorControl = ({
  facilityRef,
  selectedDate,
  onChange,
}: Props) => {
  const facility = useFragment(
    AgendaDateSelectorControlFragmentString,
    facilityRef
  );
  const clubWeekStartsOn = useGetClubStartOfWeekNumberPatron(
    facility?.club ?? null
  );

  const windowDays = facility?.club?.supportsPrivate
    ? facility?.memberBookingWindowDays ?? 14
    : facility?.publicBookingWindowDays ?? 60;

  const startDate = format(new Date(), "yyyy-MM-dd");
  const endDate = format(addDays(new Date(), windowDays), "yyyy-MM-dd");

  return (
    <AgendaDateSelectorControlInner
      startDate={startDate}
      endDate={endDate}
      selectedDate={selectedDate}
      onChange={onChange}
      clubWeekStartsOn={clubWeekStartsOn}
    />
  );
};

export const AgendaDateSelectorControlFragmentString = graphql`
  fragment AgendaDateSelectorControlFragment_facility on Facility {
    id
    publicBookingWindowDays
    memberBookingWindowDays
    club {
      supportsPrivate
      ...useGetClubStartOfWeekNumberPatron_club
    }
  }
`;
